import { render, staticRenderFns } from "./criarVoucherFamilias.vue?vue&type=template&id=4b96f40d&scoped=true"
import script from "./criarVoucherFamilias.vue?vue&type=script&lang=js"
export * from "./criarVoucherFamilias.vue?vue&type=script&lang=js"
import style0 from "./criarVoucherFamilias.vue?vue&type=style&index=0&id=4b96f40d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96f40d",
  null
  
)

export default component.exports